<template>
  <div class="">
    <el-row type="flex" justify="space-between">
      <el-col>
        <el-tooltip content="Actualizar el estado de los gps">
          <el-button
            type="primary"
            icon="el-icon-refresh"
            size="mini"
            :loading="loading"
            @click="syncAllReport"
            >Actualizar</el-button
          >
        </el-tooltip>
      </el-col>
      <el-col :span="5">
        <el-row>
          <el-col>
            <span>Clones</span>
          </el-col>
          <el-col>{{ totalGpsClones }}</el-col>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-row type="flex" align="end">
          <el-col><span>Total GPS: </span> </el-col>
          <el-col>
            <span>{{ totalGPS }}</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-row type="flex">
          <el-col>
            <el-tooltip content="Gps activos">
              <el-tag type="success">{{ total_active }}</el-tag>
            </el-tooltip>
          </el-col>
          <el-col>
            <el-tooltip content="Gps estacionado">
              <el-tag type="info">{{ total_idle }}</el-tag>
            </el-tooltip>
          </el-col>
          <el-col>
            <el-tooltip content="Gps offline por mas de 12h">
              <el-tag type="danger">{{ total_report_12h }}</el-tag>
            </el-tooltip>
          </el-col>

          <el-col>
            <el-tooltip content="Gps con señal debil">
              <el-tag type="warning">{{ total_signal_lost }}</el-tag>
            </el-tooltip>
          </el-col>
          <el-col>
            <el-tooltip content="Gps recien registrados">
              <el-tag type="info">{{ total_just_registered }}</el-tag>
            </el-tooltip>
          </el-col>
          <el-col>
            <el-tooltip content="Gps offline">
              <el-tag
                type="warning"
                style="background-color: #f7ba2a; color: #fff"
                >{{ total_offline }}</el-tag
              >
            </el-tooltip>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="table-box card-base card-shadow--medium">
      <el-table
        :data="items"
        v-loading="loading"
        border
        fit
        :default-sort="{
          prop: 'source.connection_status',
          order: 'descending'
        }"
      >
        <el-table-column :width="80" align="center" fixed>
          <template slot="header" slot-scope="scope">
            <i class="el-icon-setting" :key="scope.$index"></i>
          </template>
          <template slot-scope="scope">
            <el-tooltip content="Ver historial del GPS">
              <el-button
                type="info"
                icon="mdi mdi-history"
                :key="scope.$index"
                size="mini"
                @click="openHistoryDetail(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID #" :width="90"></el-table-column>
        <el-table-column
          prop="label"
          label="Titulo"
          :min-width="140"
        ></el-table-column>
        <el-table-column
          prop="source.connection_status"
          sortable
          sort-by="source.connection_status"
          column-key="source.connection_status"
          label="Estado"
          align="center"
          :width="150"
          :filters="[
            { text: 'Activo', value: 'active' },
            { text: 'Estacionado', value: 'idle' },
            { text: 'Offline', value: 'offline' },
            { text: 'Señal perdida', value: 'signal_lost' },
            { text: 'Recién registrado', value: 'just_registered' }
          ]"
          :filter-method="filterConectionStatus"
        >
          <template slot-scope="{ row }">
            <el-badge
              :value="row.differenceHours"
              :max="12"
              :hidden="row.lastEvent === undefined || row.differenceHours === 0"
              :type="row.differenceHours > 12 ? 'danger' : 'warning'"
            >
              <el-tag :type="getTagType(row)">{{
                row.source.connection_status
              }}</el-tag>
            </el-badge>
          </template>
        </el-table-column>
        <el-table-column prop="source.phone" label="Telefono"></el-table-column>
        <el-table-column
          prop="clone"
          label="Es clon?"
          :width="90"
          align="center"
        >
          <template slot-scope="{ row }">
            <i v-if="row.clone" class="el-icon-check"></i>
            <i v-else class="el-icon-close"></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="creation_date"
          label="Activacion"
        ></el-table-column>
      </el-table>
      <div style="margin: 10px">
        <el-pagination
          style="margin-top: 20px"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <report-gps-detail-history ref="history_detail" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import ReportGpsDetailHistory from "@/components/reports/ReportsGpsDetailHistory.vue";
import { getPaginatedItems } from "@/utils";

export default {
  name: "TableGpsStatus",
  prop: ["clientCode"],
  components: {
    ReportGpsDetailHistory
  },
  data() {
    return {
      scode: "",
      sid: 0,
      loading: false,
      items: [],
      itemsOriginal: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      totalGPS: 0,
      totalGpsClones: 0
    };
  },
  computed: {
    ...mapGetters("navixy", ["getReportGpsByCurrentUser"]),
    total_signal_lost() {
      if (this.itemsOriginal.length <= 0) {
        return 0;
      }
      return this.itemsOriginal.filter(
        (item) => item.source.connection_status === "signal_lost"
      ).length;
    },
    total_active() {
      if (this.itemsOriginal.length <= 0) {
        return 0;
      }
      return this.itemsOriginal.filter(
        (item) => item.source.connection_status === "active"
      ).length;
    },
    total_idle() {
      if (this.itemsOriginal.length <= 0) {
        return 0;
      }

      return this.itemsOriginal.filter(
        (item) => item.source.connection_status === "idle"
      ).length;
    },
    total_offline() {
      if (this.itemsOriginal.length <= 0) {
        return 0;
      }

      return this.itemsOriginal.filter(
        (item) =>
          item.source.connection_status === "offline" &&
          item.lastEvent !== undefined &&
          item.differenceHours < 12
      ).length;
    },
    total_just_registered() {
      if (this.itemsOriginal.length <= 0) {
        return 0;
      }

      return this.itemsOriginal.filter(
        (item) => item.source.connection_status === "just_registered"
      ).length;
    },
    total_report_12h() {
      if (this.itemsOriginal.length <= 0) {
        return 0;
      }

      return this.itemsOriginal.filter(
        (item) =>
          item.source.connection_status === "offline" &&
          item.lastEvent !== undefined &&
          item.differenceHours > 12
      ).length;
    }
  },
  watch: {
    getReportGpsByCurrentUser(data) {
      this.totalGpsClones = data.list.filter((f) => f.clone === true).length;
      this.totalGPS = data.count - this.totalGpsClones;
      this.pagination.total = data.count;
      this.items = data.list;
      this.itemsOriginal = data.list;
      this.handleCurrentChange(1);
    }
  },
  methods: {
    getPaginatedItems,
    ...mapMutations("navixy", ["current_user"]),
    ...mapActions("navixy", [
      "request",
      "searchUserId",
      "reportGpsByUser",
      "reportGps12H"
    ]),
    syncAllReport() {
      this.loading = true;
      this.reportGps12H({ sid: this.sid }).finally(() => {
        this.loading = false;
      });
    },
    async getItems(client_code) {
      this.scode = client_code;
      this.loading = true;

      try {
        const userId = await this.$store.dispatch("navixy/searchUserId", {
          client_code: client_code
        });

        this.sid = userId;

        if (userId > -1) {
          this.reportGps12H({ sid: userId }).finally(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
          this.$message.error("Error al consultar el id del cliente");
        }
      } catch (error) {
        console.error(error);
        this.$notify.error({
          title: "Error",
          message: "El usuario de este cliente no se ha creado en Navixy"
        });
      }
    },
    openHistoryDetail(row) {
      this.$refs.history_detail.show(row, this.activeType);
    },
    handleSizeChange(val) {
      this.loading = true;
      this.pagination.pageSize = val;
      const { data } = this.getPaginatedItems(
        this.itemsOriginal,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.loading = false;
      this.items = data;
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.pagination.currentPage = val;
      const { data } = this.getPaginatedItems(
        this.itemsOriginal,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.loading = false;
      this.items = data;
    },
    tableRowClassName({ row }) {
      const { connection_status } = row.source;

      if (connection_status === "active") {
        return "bg-success bg-green";
      } else if (connection_status === "idle") {
        return "bg-primary-lighter";
      } else if (connection_status === "signal_lost") {
        return "bg-warning bg-orange";
      } else if (connection_status === "offline") {
        return "bg-danger-light";
      }
      return "";
    },
    getTagType(row) {
      const { connection_status } = row.source;
      if (connection_status === "active") {
        return "success";
      } else if (connection_status === "idle") {
        return "primary";
      } else if (connection_status === "signal_lost") {
        return "warning";
      } else if (connection_status === "offline") {
        return "danger";
      }
      return "";
    },
    filterConectionStatus(value, row) {
      const { connection_status } = row.source;
      return connection_status === value;
    }
  }
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
